/* synthesized sound bank + tape-bending player — slow-mo halves playback speed for a pitch drop */
export function createAudio({ sfxRef, mutedRef, stateRef }) {
    // synthesized sound banks (same approach as the entry gate)
    const mkSfx = (src, volume) => {
      const audio = new Audio(src);
      audio.preload = "auto";
      audio.volume = volume;
      return audio;
    };
    sfxRef.current = {
      jump: mkSfx("/assets/game-jump.wav", 0.4),
      coin: mkSfx("/assets/game-coin.wav", 0.32),
      roar: mkSfx("/assets/worm-roar.wav", 0.6),
      heartbeat: mkSfx("/assets/heartbeat.wav", 0.7),
      blast: mkSfx("/assets/game-blast.wav", 0.5),
      slash: mkSfx("/assets/game-slash.wav", 0.45),
      screech: mkSfx("/assets/crow-screech.wav", 0.55),
      // per-boss voices — each named worm roars and slams in its own register
      "boss-roar-1": mkSfx("/assets/boss-roar-1.wav", 0.6),
      "boss-roar-2": mkSfx("/assets/boss-roar-2.wav", 0.6),
      "boss-roar-3": mkSfx("/assets/boss-roar-3.wav", 0.6),
      "boss-roar-4": mkSfx("/assets/boss-roar-4.wav", 0.6),
      "boss-roar-5": mkSfx("/assets/boss-roar-5.wav", 0.6),
      "boss-slam-1": mkSfx("/assets/boss-slam-1.wav", 0.65),
      "boss-slam-2": mkSfx("/assets/boss-slam-2.wav", 0.65),
      "boss-slam-3": mkSfx("/assets/boss-slam-3.wav", 0.65),
      "boss-slam-4": mkSfx("/assets/boss-slam-4.wav", 0.65),
      "boss-slam-5": mkSfx("/assets/boss-slam-5.wav", 0.65),
    };

    const playSfx = (name) => {
      const audio = sfxRef.current[name];
      if (!audio || mutedRef.current) return;
      // slow-mo bends sound: half-speed tape slowdown drops the pitch
      const slow = stateRef.current.slowmo > 0;
      audio.playbackRate = slow ? 0.5 : 1;
      audio.preservesPitch = !slow;
      if ("webkitPreservesPitch" in audio) audio.webkitPreservesPitch = !slow;
      audio.currentTime = 0;
      audio.play().catch(() => {});
    };

  return { playSfx };
}
